/* Student-only modal that gates chat usage behind integrity acknowledgement. */
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import APIService from '../APIService';

function AcademicIntegrityDisclaimer() {
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {APIService.OpenAcademicIntegrityDisclaimer(setOpenModal)}, []);
    
    return  <>
                <Modal className="academic-integrity-disclaimer-modal" show={openModal} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <p>
                            I understand that using any AI tool in any phase of 
                            an assignment without permission from the course 
                            instructor is a violation of Miami's academic 
                            integrity policy. I also understand that use of the 
                            AI Tutor tool is for the purposes of aiding 
                            learning, and that I may not use the tool to 
                            complete academic work in an unauthorized manner. I 
                            understand that if I use the AI Tutor tool in a 
                            manner not authorized by my instructors that I will 
                            be charged with a violation of the Academic 
                            Integrity Policy.
                        </p>
                        <p>
                            I attest that I have received express permission 
                            from my instructors to use the AI Tutor tool and 
                            that I will not use it in an unauthorized manner.
                        </p>
                        <div className="text-center">
                            <Button className="btn-lg academic-integrity-disclaimer-button" onClick={() => APIService.AcceptAcademicIntegrityDisclaimer(setOpenModal)}>
                                Accept
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
}

export default AcademicIntegrityDisclaimer;
